import * as Action from "@actions/index";

const InitialState = {
  status: "loading",
  statusBase: "loading",
  statusFull: "loading",
  paginator: {},
  paginatorBase: {},
  paginatorFull: {},
  list: [],
  listBase: [],
  listFull: [],
  error: "",
};

export default (state = InitialState, action: any) => {
  switch (action.type) {
    case Action.Main.Rating.SET_LIST:
      return { ...state, list: action.data };
    case Action.Main.Rating.SET_LIST_BASE:
      return { ...state, listBase: action.data };
    case Action.Main.Rating.SET_LIST_FULL:
      return { ...state, listFull: action.data };
    case Action.Main.Rating.SET_PAGINATOR:
      return { ...state, paginator: action.data };
    case Action.Main.Rating.SET_PAGINATOR_BASE:
      return { ...state, paginatorBase: action.data };
    case Action.Main.Rating.SET_PAGINATOR_FULL:
      return { ...state, paginatorFull: action.data };
    case Action.Main.Rating.SET_STATUS:
      return { ...state, status: action.data };
    case Action.Main.Rating.SET_STATUS_BASE:
      return { ...state, statusBase: action.data };
    case Action.Main.Rating.SET_STATUS_FULL:
      return { ...state, statusFull: action.data };
    case Action.Main.Rating.SET_ERROR:
      return { ...state, error: action.data };
    case Action.Main.Rating.CLEAR:
      return { ...state, data: {} };
    default:
      return state;
  }
};
